import React from 'react'

export default React.createContext({
  activeEditor: {},
  updateActiveEditor: (e) => {},
})
